// Item values are stored by field key (Migrator v4); a field's `name` is only its label.

/**
 * Reserved key: until slice 6 the place was stored under it in field_values;
 * since v8 it is items.location_id, and the API names `location` as the field
 * of a refused place (400 invalid_value).
 */
export const LOCATION_KEY = 'location';

/** Values the v4 migration could not place in a field are kept under x_ keys. */
export const ORPHAN_PREFIX = 'x_';

/** The key a field's value is stored under. */
export const fieldKey = (field) => field.key || field.name;

/** Values with no field of their own that an edit must carry over. */
export const isPreservedKey = (key) => key.startsWith(ORPHAN_PREFIX);
